import axios from 'axios';

// Declarar tipos para process.env
declare const process: {
  env: {
    NODE_ENV: string;
    REACT_APP_API_URL?: string;
    REACT_APP_ENVIRONMENT?: string;
  };
};

// Determinar la URL base de la API
const getBaseURL = () => {
  const apiUrl = process.env.REACT_APP_API_URL;
  const environment = process.env.REACT_APP_ENVIRONMENT || process.env.NODE_ENV;
  
  // Prioridad: Variable de entorno específica
  if (apiUrl) {
    return apiUrl;
  }
  
  // En producción, usar URL de Railway
  if (environment === 'production') {
    return 'https://cuerdacl-production.up.railway.app/api/v1';
  }
  
  // En desarrollo, usar localhost
  return 'http://localhost:8000/api/v1';
};

const baseURL = getBaseURL();

const api = axios.create({
  baseURL,
  timeout: 15000,
  headers: {
    'Content-Type': 'application/json',
  }
});

// Interceptor para agregar token de autorización - ZERO LOGGING
api.interceptors.request.use(
  (config: any) => {
    const token = localStorage.getItem('access_token');
    
    if (token) {
      config.headers = config.headers || {};
      config.headers.Authorization = `Bearer ${token}`;
    }
    
    return config;
  },
  (error: any) => {
    // Sin logging para proteger información sensible
    return Promise.reject(error);
  }
);

// Interceptor para manejar respuestas y errores - ZERO LOGGING
api.interceptors.response.use(
  (response: any) => {
    // Sin logging para proteger datos sensibles
    return response;
  },
  (error: any) => {
    const { response } = error;
    
    // Solo manejar errores críticos sin logging
    if (response?.status === 401) {
      localStorage.removeItem('access_token');
      window.location.href = '/login';
    }
    
    return Promise.reject(error);
  }
);

// Health check function - SIN LOGGING
export const healthCheck = async () => {
  try {
    const response = await api.get('/health');
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Test de conectividad - SIN LOGGING
export const testConnection = async () => {
  try {
    const response = await api.get('/');
    return response.data;
  } catch (error) {
    throw error;
  }
};

export default api; 
